import React, { useEffect, useState } from 'react'

const PageContext = React.createContext()

function PageProvider({ children }) {
    const [currentPage, setCurrentPage] = useState('timecontrol');
    useEffect(() => {
        setCurrentPage(window.location.pathname.split('/')[2])
    }, [window.location]);
    return (
        <PageContext.Provider value={{
            currentPage,
            setCurrentPage
        }}>
            {children}
        </PageContext.Provider>
    )
}

export { PageContext, PageProvider }